import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-9e59545a")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" No hay datos para mostrar ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Aguarde mientras se cargan las comisiones ")
const _hoisted_3 = { style: {"width":"100%"} }
const _hoisted_4 = { style: {"width":"20%"} }
const _hoisted_5 = { style: {"vertical-align":"middle","text-align":"left"} }
const _hoisted_6 = { style: {"vertical-align":"middle","text-align":"right","padding-right":"10pt"} }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "p-text-bold" }, "País", -1)
const _hoisted_9 = { style: {"height":"100%"} }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "p-text-bold" }, "Cursos", -1)
const _hoisted_11 = { style: {"height":"100%"} }
const _hoisted_12 = {
  key: 0,
  class: "p-d-flex p-jc-center"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "p-text-bold" }, "Promedio", -1)
const _hoisted_14 = { class: "spnSlider" }
const _hoisted_15 = { style: {"height":"100%"} }
const _hoisted_16 = {
  key: 0,
  class: "p-d-flex p-ml-3"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "p-text-bold" }, "Rating", -1)
const _hoisted_18 = { class: "spnSlider" }
const _hoisted_19 = { style: {"height":"100%"} }
const _hoisted_20 = { class: "p-d-flex p-ml-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "p-text-bold" }, "Cantidad Asig.", -1)
const _hoisted_22 = { style: {"height":"100%"} }
const _hoisted_23 = { class: "p-d-flex p-ml-3" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "p-text-bold" }, "Warmup", -1)
const _hoisted_26 = { class: "p-field-checkbox p-mt-3" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { for: "warmupDone" }, "Realizada", -1)
const _hoisted_28 = { class: "p-field-checkbox p-mt-3" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { for: "warmupUnrealized" }, "No realizada", -1)
const _hoisted_30 = { class: "p-d-flex p-jc-center" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "p-text-bold" }, "Kickoff", -1)
const _hoisted_33 = { class: "p-field-checkbox p-mt-3" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { for: "kickoffDone" }, "Realizada", -1)
const _hoisted_35 = { class: "p-field-checkbox p-mt-3" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { for: "kickoffUnrealized" }, "No realizada", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmailSending = _resolveComponent("EmailSending")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CountrySelector = _resolveComponent("CountrySelector")!
  const _component_Column = _resolveComponent("Column")!
  const _component_CoursePlanSelector = _resolveComponent("CoursePlanSelector")!
  const _component_CoderBadge = _resolveComponent("CoderBadge")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_EmailSending, {
      visible: _ctx.showEmailSendingModal,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_ctx.showEmailSendingModal = $event)),
      contextId: _ctx.contextId,
      setMail: _ctx.setMail
    }, null, 8, ["visible", "contextId", "setMail"]),
    _createVNode(_component_DataTable, {
      class: "performance-table p-datatable-ssm",
      responsiveLayout: "scroll",
      filterDisplay: "menu",
      filters: _ctx.filters,
      "onUpdate:filters": [
        _cache[11] || (_cache[11] = ($event: any) => (_ctx.filters = $event)),
        _ctx.updateFilters
      ],
      lazy: true,
      paginator: true,
      rows: _ctx.recordsPerPage,
      totalRecords: _ctx.totalRecord,
      first: _ctx.firstRecord,
      value: _ctx.staffData,
      onPage: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('page', $event)))
    }, {
      empty: _withCtx(() => [
        _hoisted_1
      ]),
      loading: _withCtx(() => [
        _hoisted_2
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          header: "Nombre",
          field: "name",
          columnKey: "country",
          filterField: "countries",
          showFilterMatchModes: false,
          hidden: !_ctx.filters.columns.value.includes('name')
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("table", null, [
                _createElementVNode("td", _hoisted_4, [
                  _createVNode(_component_Button, {
                    class: "p-button-text overlay-menu-trigger",
                    icon: "pi pi-envelope",
                    onClick: ($event: any) => (_ctx.openEmailSendingModal(data.email, data.country, data.userId))
                  }, null, 8, ["onClick"])
                ]),
                _createElementVNode("td", _hoisted_5, [
                  _createVNode(_component_router_link, {
                    to: {
                  name: _ctx.EducationRouteNames.PERSON_PROFILE_GENERAL,
                  params: {
                    personId: data.userId
                  }
                }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.firstName) + " " + _toDisplayString(data.lastName), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createElementVNode("td", _hoisted_6, [
                  _createElementVNode("img", {
                    class: "p-ml-4 p-mr-0",
                    src: _ctx.Country.getIconUrlFromCountryCode(data.country),
                    alt: data.country
                  }, null, 8, _hoisted_7)
                ])
              ])
            ])
          ]),
          filter: _withCtx(({ filterModel }) => [
            _hoisted_8,
            _createVNode(_component_CountrySelector, {
              class: "p-mt-3",
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              disabled: _ctx.loading
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
          ]),
          filterclear: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              label: "Limpiar",
              onClick: ($event: any) => (filterCallback()),
              class: "p-button-text button-underlined"
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["hidden"]),
        _createVNode(_component_Column, {
          header: "Cursos",
          bodyClass: "bg-gray",
          style: {"padding":"0px"},
          filterField: "coursePlans",
          showFilterMatchModes: false,
          field: _ctx.ColumnFields.CoursePlans,
          hidden: !_ctx.filters.columns.value.includes('coursePlan')
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("table", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.courses, (course) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: course,
                  class: "trRowStaffData"
                }, [
                  _createElementVNode("td", {
                    class: _normalizeClass(_ctx.getStyleColumn(data.courses, course))
                  }, _toDisplayString(course.courseName), 3)
                ]))
              }), 128))
            ])
          ]),
          filter: _withCtx(() => [
            _hoisted_10,
            _createVNode(_component_CoursePlanSelector, {
              class: "p-mt-3",
              modelValue: _ctx.filters.coursePlans.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters.coursePlans.value = $event)),
              disabled: _ctx.loading,
              coursePlans: _ctx.allCoursePlans,
              multipleSelection: true,
              filter: true
            }, null, 8, ["modelValue", "disabled", "coursePlans"])
          ]),
          filterclear: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              class: "p-button-text button-underlined",
              label: "Limpiar",
              onClick: ($event: any) => (filterCallback())
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["field", "hidden"]),
        _createVNode(_component_Column, {
          header: "Promedio finalizadas",
          bodyClass: "bg-gray",
          filterField: "finishedAverage",
          style: {"padding":"0px"},
          showFilterMatchModes: false,
          field: _ctx.ColumnFields.FinishedAverage,
          hidden: !_ctx.filters.columns.value.includes('finishedAverage')
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("table", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.courses, (course) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: course,
                  class: "trRowStaffData"
                }, [
                  _createElementVNode("td", {
                    class: _normalizeClass(_ctx.getStyleColumn(data.courses, course))
                  }, [
                    (course.finishedAverage)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createVNode(_component_CoderBadge, {
                            text: course.finishedAverage,
                            backgroundColor: _ctx.getBackgroundColor(course.finishedAverage),
                            fontSize: "12px",
                            padding: "0px 8px",
                            rounded: ""
                          }, null, 8, ["text", "backgroundColor"])
                        ]))
                      : _createCommentVNode("", true)
                  ], 2)
                ]))
              }), 128))
            ])
          ]),
          filter: _withCtx(() => [
            _hoisted_13,
            _createVNode(_component_Slider, {
              class: "p-mt-3",
              modelValue: _ctx.filters.finishedAverage.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filters.finishedAverage.value = $event)),
              min: 0,
              max: 5,
              step: 0.1,
              range: true
            }, null, 8, ["modelValue", "step"]),
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.sliderLabel(_ctx.filters.finishedAverage.value)), 1)
          ]),
          filterclear: _withCtx(() => [
            _createVNode(_component_Button, {
              class: "p-button-text button-underlined",
              label: "Limpiar",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cleanSlider([_ctx.StaffFiltersProps.finishedAverage])))
            })
          ]),
          _: 1
        }, 8, ["field", "hidden"]),
        _createVNode(_component_Column, {
          header: "Rating última comisión",
          bodyClass: "bg-gray",
          filterField: "lastCommissionRating",
          style: {"padding":"0px"},
          showFilterMatchModes: false,
          field: _ctx.ColumnFields.LastCommissionRating,
          hidden: !_ctx.filters.columns.value.includes('lastCommissionRating')
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("table", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.courses, (course) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: course,
                  class: "trRowStaffData"
                }, [
                  _createElementVNode("td", {
                    class: _normalizeClass(_ctx.getStyleColumn(data.courses, course))
                  }, [
                    (course.lastCommission)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createVNode(_component_router_link, {
                            to: {
                    name: _ctx.EducationRouteNames.COURSE_DETAIL,
                    params: {
                      courseId: course.lastCommission?.courseNumber
                    }
                  }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(course.lastCommission.courseNumber), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]),
                          _createVNode(_component_CoderBadge, {
                            text: course.lastCommission.rating,
                            backgroundColor: _ctx.getBackgroundColor(course.lastCommission.rating),
                            fontSize: "12px",
                            padding: "0px 8px",
                            rounded: ""
                          }, null, 8, ["text", "backgroundColor"])
                        ]))
                      : _createCommentVNode("", true)
                  ], 2)
                ]))
              }), 128))
            ])
          ]),
          filter: _withCtx(() => [
            _hoisted_17,
            _createVNode(_component_Slider, {
              class: "p-mt-3",
              modelValue: _ctx.filters.lastCommissionRating.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filters.lastCommissionRating.value = $event)),
              min: 0,
              max: 5,
              step: 0.1,
              range: true
            }, null, 8, ["modelValue", "step"]),
            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.sliderLabel(_ctx.filters.lastCommissionRating.value)), 1)
          ]),
          filterclear: _withCtx(() => [
            _createVNode(_component_Button, {
              class: "p-button-text button-underlined",
              label: "Limpiar",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.cleanSlider([_ctx.StaffFiltersProps.lastCommissionRating])))
            })
          ]),
          _: 1
        }, 8, ["field", "hidden"]),
        _createVNode(_component_Column, {
          header: "Rating asignaciones activas",
          bodyClass: "bg-gray",
          filterField: "activeCommissionsCount",
          style: {"padding":"0px"},
          field: _ctx.ColumnFields.ActiveCommissionsCount,
          showFilterMatchModes: false,
          hidden: !_ctx.filters.columns.value.includes('activeCommissionsCount')
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("table", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.courses, (course) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: course,
                  class: "trRowStaffData"
                }, [
                  _createElementVNode("td", {
                    class: _normalizeClass(_ctx.getStyleColumn(data.courses, course))
                  }, [
                    _createElementVNode("div", _hoisted_20, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(course.activeCommissions, (commission) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: commission,
                          class: "p-d-flex p-ml-3"
                        }, [
                          _withDirectives(_createVNode(_component_router_link, {
                            to: {
                      name: _ctx.EducationRouteNames.COURSE_DETAIL,
                      params: {
                        courseId: commission.courseNumber
                      }
                    }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(commission.courseNumber), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]), [
                            [
                              _directive_tooltip,
                              _ctx.getToolTip(commission.courseDates),
                              void 0,
                              { bottom: true }
                            ]
                          ]),
                          (commission.rating)
                            ? (_openBlock(), _createBlock(_component_CoderBadge, {
                                key: 0,
                                text: commission.rating,
                                backgroundColor: _ctx.getBackgroundColor(commission.rating),
                                fontSize: "12px",
                                padding: "0px 8px",
                                rounded: ""
                              }, null, 8, ["text", "backgroundColor"]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ], 2)
                ]))
              }), 128))
            ])
          ]),
          filter: _withCtx(() => [
            _hoisted_21,
            _createVNode(_component_InputText, {
              class: "p-mt-3",
              modelValue: _ctx.filters.activeCommissionsCount.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.filters.activeCommissionsCount.value = $event))
            }, null, 8, ["modelValue"])
          ]),
          filterclear: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              class: "p-button-text button-underlined",
              label: "Limpiar",
              onClick: ($event: any) => (filterCallback())
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["field", "hidden"]),
        _createVNode(_component_Column, {
          header: "Warmup",
          bodyClass: "bg-gray",
          filterField: "warmup",
          style: {"padding":"0px"},
          field: _ctx.ColumnFields.Warmup,
          showFilterMatchModes: false,
          hidden: !_ctx.filters.columns.value.includes('warmup')
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("table", _hoisted_22, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.courses, (course) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: course,
                  class: "trRowStaffData"
                }, [
                  _createElementVNode("td", {
                    class: _normalizeClass(_ctx.getStyleColumn(data.courses, course))
                  }, [
                    _createElementVNode("div", _hoisted_23, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(course.activeCommissions, (commission) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: commission,
                          class: "p-d-flex p-ml-3"
                        }, [
                          (commission.warmup)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.formatDate(commission.warmup)), 1))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ], 2)
                ]))
              }), 128))
            ])
          ]),
          filter: _withCtx(() => [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_Checkbox, {
                name: "wuDone",
                binary: true,
                modelValue: _ctx.wuDone,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.wuDone = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_27
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_Checkbox, {
                name: "koUnrealized",
                binary: true,
                modelValue: _ctx.wuUnrealized,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.wuUnrealized = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_29
            ])
          ]),
          filterclear: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              class: "p-button-text button-underlined",
              label: "Limpiar",
              onClick: ($event: any) => (filterCallback())
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["field", "hidden"]),
        _createVNode(_component_Column, {
          header: "Kick-Off",
          bodyClass: "bg-gray",
          style: {"padding":"0px"},
          filterField: "kickoff",
          showFilterMatchModes: false,
          field: _ctx.ColumnFields.Kickoff,
          hidden: !_ctx.filters.columns.value.includes('kickoff')
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_30, [
              (data.teacherKickOff)
                ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.formatDate(data.teacherKickOff)), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          filter: _withCtx(() => [
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_component_Checkbox, {
                name: "koDone",
                binary: true,
                modelValue: _ctx.koDone,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.koDone = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_34
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_Checkbox, {
                name: "koUnrealized",
                binary: true,
                modelValue: _ctx.koUnrealized,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.koUnrealized = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_36
            ])
          ]),
          filterclear: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              class: "p-button-text button-underlined",
              label: "Limpiar",
              onClick: ($event: any) => (filterCallback())
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["field", "hidden"])
      ]),
      _: 1
    }, 8, ["filters", "rows", "totalRecords", "first", "value", "onUpdate:filters"])
  ], 64))
}